import React from "react";

export const InputActionTemplate = ({ actionImageElement, spanElement, previewMessage, cancelImageElement }) => {
    return (
        <div className="input-container" style={{ paddingLeft: "2.75rem", paddingRight: "3.20rem", background: "#FFF", display: "flex", justifyContent: "space-between" }}>
            <div>
                <div style={{ display: "flex", alignItems: "center", color: "#001191", fontSize: "0.75rem", gap: "5px", marginBottom: "3px" }}> 
                    {actionImageElement}
                    {spanElement}
                </div>
                <div style={{ color: "#9A9A9A", fontSize: "0.75rem" }}>{ previewMessage }</div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>{ cancelImageElement }</div>
        </div>
    );
};

